import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

const state = () => ({
  globalConfiguration: [],
  userConfiguration: 
    {
      "lineid": null,
      "setting": {
        "investlvl": "0",
        "language": "TH",
        "theme": "light",
        "assets": [
          "fund",
          // "stock",
          // "indices",
          "gold",
          // "crypto",
          // "lotto",
          "savings"
        ]
      },
      "onboarding": [],
      "pdpa": {
        "termsandcondition": false
      }
    }
  ,
})

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
